export type User = {
  sub: string;
  email: string;
  firstName: string;
  groupIds: string[] | undefined;
  lastName: string;
  name: string;
  phone: string | undefined;
  status: string;
  username: string;
  emailgroupIds?: string[];
};

export const unknownUser: User = {
  sub: '',
  name: '',
  email: '',
  phone: '',
  status: '',
  username: '',
  groupIds: [],
  firstName: '',
  lastName: '',
};

export interface UserAttribute {
  Name: string;
  Value: string;
}
